import React, { useEffect, useMemo } from "react";
import { IColumnProps } from "devextreme-react/data-grid";
import { IItemProps } from "devextreme-react/form";

import { PageProps, UpdateDomTitleForForm } from "@ezhou/core";
import { MainCard } from "@ezhou/app_mantis_1_1";

import { InactivatableCrudDataGrid } from "../common/InactivatableCrudDataGrid";

import { dummyCustomerRow } from "./model/metaData";
import { CustomerOrganizations } from "./CustomerOrganizations";

const Customers = (pageProps: PageProps) => {
  const logger = pageProps.loggerProvider.getLogger("CustomersPage");

  useEffect(() => {
    UpdateDomTitleForForm(pageProps);
  });

  const columnConfigs = useMemo(
    () =>
      new Map<string, IColumnProps>([
        ["customerId", { dataField: "customerId", caption: "Customer ID" }],
        ["fullName", { dataField: "fullName", caption: "Full Name" }],
        ["shortName", { dataField: "shortName", caption: "Short Name" }],
        [
          "licenseExpirationDate",
          { dataField: "licenseExpirationDate", caption: "License Expiration Date", dataType: "date" },
        ],
        [
          "maximumTransactionCount",
          { dataField: "maximumTransactionCount", caption: "Maximum Transaction Count", dataType: "number" },
        ],
        ["active", { dataField: "active", caption: "Active", dataType: "boolean" }],
      ]),
    [],
  );

  const editorItemOptions = useMemo(
    () =>
      new Map<string, IItemProps>([
        ["licenseExpirationDate", { editorType: "dxDateBox", editorOptions: { type: "date" } }],
        ["maximumTransactionCount", { editorType: "dxNumberBox", editorOptions: { min: 0, showSpinButtons: true } }],
      ]),
    [],
  );

  const detailComponent = (props: any) => {
    return <CustomerOrganizations masterData={props.data.data} pageProps={pageProps} logger={logger} />;
  };

  return (
    <MainCard>
      <InactivatableCrudDataGrid
        pageProps={pageProps}
        logger={logger}
        dummyRow={dummyCustomerRow}
        baseUrl="customers"
        keyExpr="customerId"
        isKeyAutoGenerated={true}
        formTitle="Customer"
        formColCount={2}
        formColSpan={2}
        columnConfigs={columnConfigs}
        editorItemOptions={editorItemOptions}
        masterDetailComponent={detailComponent}
        allowAdding={true}
        allowUpdating={true}
        allowDeleting={true}
      ></InactivatableCrudDataGrid>
    </MainCard>
  );
};

export default Customers;
